module.exports = __webpack_public_path__ + "static/media/intro.1bd8dd8f.mp3";